import axios from "axios";
import { requestID, baseUrl, config } from "../../common/utils";
// import { baseUrl, config, requestID } from "../../../common/utils";

export const getCustomers = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "users/getAllCustomersData",
            data,
            config
        );
        console.log("customers", response)
        return response.data

    } catch (error: any) {
        return error
    }

}

 
export const updateCustomerDetails = async (payload) => {
    console.log('updateCustomerDetails payload', payload)
    const data = {  
        requestID: requestID(),...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "users/updateCustomerDetails",
            data,
            config
        );
        console.log({ response });
        return response.data;
    } catch (error: any) {
        return error;
    }
};

export const zeroFundingHistoryApi = async (user_id) => {
    const data = {
        requestID: requestID(),customer_user_id:user_id
    };//ZeroCustomerWallet zeroFundingHistoryApi
    try {
        const response = await axios.post(
            baseUrl() + "wallets/zeroFundingHistoryApi",
            data,
            config
        );
         console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}



export const fetchFundingHistoryApi = async (user_id) => {
    const data = {
        requestID: requestID(),user_id
    };
    try {
        const response = await axios.post(
            baseUrl() + "wallets/fetchFundingHistoryApi",
            data,
            config
        );
        // console.log({ response.data })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const createCustomer = async (payload) => {
    const data = {
        requestID: requestID(),...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "users/addCustomer",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const getAllCustomers = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "users/getCustomers",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}




export const getProductPerformance = async (payload) => {

    
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "users/getProductPerformance",
            data,
            config
        );
        console.log({ response })
               
        return response.data

    } catch (error: any) {
        return error
    }

}


export const getCustomerTransactionReport = async (payload) => {
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "users/getCustomerTransactionReport_Ex",
            data,
            config
        );
        console.log({ response })
        return response.data
    } catch (error: any) {
        return error
    }

}
export const getCustomerPerformance = async (payload) => {

    
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "users/getCustomerPerformance",
            data,
            config
        );
        console.log({ response })
               
        return response.data

    } catch (error: any) {
        return error
    }

}


export const getCustomerPerformance_Ex = async (payload) => {

    
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "users/getCustomerPerformance_Ex",
            data,
            config
        );
        console.log({ response })
               
        return response.data

    } catch (error: any) {
        return error
    }

}


export const getStaffTransactionReport = async (payload) => {

    
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "users/getAllBusinessStaffWithReport",
            data,
            config
        );
        console.log({ response })
               
        return response.data

    } catch (error: any) {
        return error
    }

}


export const getStaffPerformance = async (payload) => {

    
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "users/getAllBusinessStaff",
            data,
            config
        );
        console.log({ response })
               
        return response.data

    } catch (error: any) {
        return error
    }

}


export const membersWithCreditBalance = async () => {

    
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/membersWithCreditBalance",
            data,
            config
        );
        console.log({ response })
               
        return response.data

    } catch (error: any) {
        return error
    }

}
export const membersWithBalance = async () => {

    
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/membersWithBalance",
            data,
            config
        );
        console.log({ response })
               
        return response.data

    } catch (error: any) {
        return error
    }

}


// export const getAllCustomers23 = async () => {

    export const getAllCustomers23 = async (offset: number, limit: number, search?: string) => {
//   try {
//     const response = await api.get('/customers', {
//       params: { offset, limit, search }
//     });

    const data = {
        requestID: requestID(),offset,limit,search
    };
    try {
        const response = await axios.post(
            baseUrl() + "users/getCustomers23",
            data,
            config
        );
        console.log(response.data);
               
        return response.data

    } catch (error: any) {
        return error
    }

}
export const getAllCustomers2 = async () => {

    
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "users/getCustomers2",
            data,
            config
        );
        console.log({ response })
               
        return response.data

    } catch (error: any) {
        return error
    }

}

export const getCustomersProfitReport = async ( branch_id,
        startDate,
        endDate) => {

    
    const data = {
        requestID: requestID(),
        ...branch_id
        
    };
    
    try {
        const response = await axios.post(
            baseUrl() + "users/getCustomersProfitReport",
            data,
            config
        );
        console.log({ response })
               
        return response.data

    } catch (error: any) {
        return error
    }

}




export const searchCustomersLive = async () => {
    const data = {
        requestID: requestID(),
      
    };
    try {
        const response = await axios.post(
            baseUrl() + "users/searchCustomersLive",
            data,
            config
        );
        console.log('search', response )
        return response.data

    } catch (error: any) {
        return error
    }

}
export const searchCustomers = async (payload) => {
    const data = {
        requestID: requestID(),
        data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "users/searchCustomers",
            data,
            config
        );
        console.log('search', response )
        return response.data

    } catch (error: any) {
        return error
    }

}

export const searchTransactionsByPhone_Name_email = async (id) => {
    const data = {
        requestID: requestID(),
        searchword:id
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/searchTransactionsByPhone_Name_email",
            data,
            config
        );
        console.log({ response })
                console.log( response.data )

        return response.data

    } catch (error: any) {
        return error
    }

}
export const searchTransactionsByCode = async (id) => {
    const data = {
        requestID: requestID(),
        searchword:id
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getCustomersOrders_giftcard_crypto_by_code",
            data,
            config
        );
        console.log({ response })
                console.log( response.data )

        return response.data

    } catch (error: any) {
        return error
    }

}

export const searchTransactionsByCode1 = async (payload) => {
    const data = {
        requestID: requestID(),
        data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "users/searchTransactionsByCode",
            data,
            config
        );
        console.log('search', response )
        return response.data

    } catch (error: any) {
        return error
    }

}



export const getCustomerGrades = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "warehouses/getAll_customer_product_grade",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}



    export const getCustomersOrders_crypto = async () => {
        const data = {
            requestID: requestID(),
        
        };
        try {
            const response = await axios.post(
                baseUrl() + "orderhistorys/getCustomersOrders_crypto",
                data,
                config
            );
            console.log({ response })
                    console.log( response.data )

            return response.data

        } catch (error: any) {
            return error
        }

    }


    export const getCustomersOrders_giftcard_crypto_all = async () => {
        const data = {
            requestID: requestID(),
        
        };
        try {
            const response = await axios.post(
                baseUrl() + "orderhistorys/getCustomersOrders_giftcard_crypto_all",
                data,
                config
            );
            console.log({ response })
                    console.log( response.data )

            return response.data

        } catch (error: any) {
            return error
        }

    }


     

    export const confirmTransactionAPI = async (order_id) => {
        const data = {
            requestID: requestID(),
            order_id
        };
        try {
            const response = await axios.post(
                baseUrl() + "orderhistorys/confirmTransactionPayout",
                data,
                config
            );
            console.log({ response })
            return response.data

        } catch (error: any) {
            return error
        }

    }


    

    export const getCustomersOrders_conf_crypto = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getCustomersOrders_conf_crypto",
            data,
            config
        );
        console.log({ response })
        console.log( response.data )

        return response.data

    } catch (error: any) {
        return error
    }

}



    export const fetchCustomerTransactions_conf_crypto = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/fetchCustomerTransactions_conf_crypto",
            data,
            config
        );
        console.log({ response })
        console.log( response.data )

        return response.data

    } catch (error: any) {
        return error
    }

}


    export const getCustomersOrders_conf_giftcard_crypto_all = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getCustomersOrders_conf_giftcard_crypto_all",
            data,
            config
        );
        console.log({ response })
        console.log( response.data )

        return response.data

    } catch (error: any) {
        return error
    }

}

export const getCustomersOrders_giftcard_crypto = async (id) => {
    const data = {
        requestID: requestID(),
        customer_id:id
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getCustomersOrders_giftcard_crypto",
            data,
            config
        );
        console.log({ response })
                console.log( response.data )

        return response.data

    } catch (error: any) {
        return error
    }

}



export const CheckOutCustomers = async (order_id) => {
    const data = {
        requestID: requestID(),
        order_id:order_id
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/checkOutCustomers",
            data,
            config
        );
        console.log({ response })
                console.log( response.data )

        return response.data

    } catch (error: any) {
        return error
    }

}
export const getCustomersOrders_checkInCheckOut = async () => {
    const data = {
        requestID: requestID(),
        //customer_id:id
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getCustomersOrders_checkInCheckOut",
            data,
            config
        );
        console.log({ response })
                console.log( response.data )

        return response.data

    } catch (error: any) {
        return error
    }

}


export const getCustomersOrders_pending = async () => {
    const data = {
        requestID: requestID(),
        //customer_id:id
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getCustomersOrders_pending",
            data,
            config
        );
        console.log({ response })
                console.log( response.data )

        return response.data

    } catch (error: any) {
        return error
    }

}



export const getCustomersWithPendingTransactions_crm = async () => {
    const data = {
        requestID: requestID(),
        //customer_id:id
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getCustomersOrders_pending_crm",
            data,
            config
        );
        console.log({ response })
                console.log( response.data )

        return response.data

    } catch (error: any) {
        return error
    }

}

export const getCustomerOnlineBooking = async () => {
    const data = {
        requestID: requestID(),
        //customer_id:id
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getCustomerOnlineBooking",
            data,
            config
        );
        console.log({ response })
                console.log( response.data )

        return response.data

    } catch (error: any) {
        return error
    }

}

export const getCustomersWithPendingTransactions_crm_admin = async () => {
    const data = {
        requestID: requestID(),
        //customer_id:id
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getCustomersOrders_pending_crm_admin",
            data,
            config
        );
        console.log({ response })
                console.log( response.data )

        return response.data

    } catch (error: any) {
        return error
    }

}


export const getCustomersWithPendingTransactions = async () => {
    const data = {
        requestID: requestID(),
        //customer_id:id
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getCustomersOrders_giftcard_crypto_pending",
            data,
            config
        );
        console.log({ response })
                console.log( response.data )

        return response.data

    } catch (error: any) {
        return error
    }

}

 

export const getCustomerTransactions_exchange = async (id) => {
    const data = {
        requestID: requestID(),
        customer_id:id
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getCustomerOrders_exchange",
            data,
            config
        );
        console.log({ response })
                console.log( response )

        return response.data

    } catch (error: any) {
        return error
    }

}
export const getCustomerTransactionsWithDateRange = async (id, dateRange) => {
    const data = {
        requestID: requestID(),
        customer_id:id,
        start_date: dateRange.startDate,
        end_date: dateRange.endDate
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getCustomerOrders",
            data,
            config
        );
        console.log({ response })
                console.log( response )

        return response.data

    } catch (error: any) {
        return error
    }

}

export const getCustomerTransactions = async (id) => {
    const data = {
        requestID: requestID(),
        customer_id:id
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getCustomerOrders",
            data,
            config
        );
        console.log({ response })
                console.log( response )

        return response.data

    } catch (error: any) {
        return error
    }

}

export const getCustomerTransactionsWithDate = async (id,start,end) => {
    const data = {  
        requestID: requestID(),
        customer_id:id,
        start_date:start,
        end_date:end
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getCustomerOrdersWithDate",
            data,
            config
        );
        console.log({ response })
                console.log( response )

        return response.data

    } catch (error: any) {
        return error
    }

}

export const getCustomerTransactionsWithDate_Next = async (id,start,end,pageToken) => {
    const data = {  
        requestID: requestID(),
        customer_id:id,
        start_date:start,
        end_date:end,
        page_token:pageToken
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getCustomerOrdersWithDateNext",
            data,
            config
        );
        console.log({ response })
                console.log( response )

        return response.data

    } catch (error: any) {
        return error
    }

}


export const createCustomerPayment = async (payload) => {
    const data = {
        requestID: requestID(),...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/recordCustomerOrders",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const createCustomerPayment_giftcard_crypto = async (payload) => {
    const data = {
        requestID: requestID(),...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/recordCustomerOrders_giftcard_crypto",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}


// export const createCustomerPayment_crypto = async (payload) => {
//     const data = {
//         requestID: requestID(),...payload
//     };
//     try {
//         const response = await axios.post(
//             baseUrl() + "orderhistorys/createCustomerPayment_crypto",
//             data,
//             config
//         );
//         console.log({ response })
//         return response.data

//     } catch (error: any) {
//         return error
//     }

// }

//lola
export const createCustomerPayment_giftcard_crypto_all = async (payload) => {
    const data = {
        requestID: requestID(),...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/recordCustomerOrders_giftcard_crypto_all",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const createCustomerPayment_conf_giftcard_crypto_all = async (payload) => {
    const data = {
        requestID: requestID(),...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/recordCustomerOrders_conf_giftcard_crypto_all",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const orderReport = async (payload) => {
    const data = {
        requestID: requestID(), ...payload
        // data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/orderReport",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}


export const approvedOrders = async (payload) => {
    const data = {
        requestID: requestID(), ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/approvedOrders",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}



export const getCustomerWallet = async () => {
    const data = {
        requestID: requestID()
    };
    try {
        const response = await axios.post(
            baseUrl() + "wallets/getWalletMaster_ledger2",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

 
export const getCustomerBanks = async (customerId: string) => {
  try {
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("member_id", customerId);

    const response = await axios.post(
      baseUrl() + "orderhistorys/getCustomerBanks",
      formData,
      config
    );

    console.log("getCustomerBanks Response :", response.data);

    return response;
  } catch (error: any) {
    console.error("Error getCustomerBanks bank account:", error);
    return error.response?.data || { message: error.message };
  }
};


export const addCustomerBanks = async (
  customerId: string,
  bankdetails: any
) => {
  try {
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("member_id", customerId);
    formData.append("bank_code", bankdetails.bankCode);
    formData.append("account_number", bankdetails.accountNumber);
    formData.append("account_name", bankdetails.accountName);
    const response = await axios.post(
      baseUrl() + "orderhistorys/AddCustomerBank",
      formData,
      config
    );

    console.log("addCustomerBanks Response :", response.data);

    return response;
  } catch (error: any) {
    console.error("Error addCustomerBanks bank account:", error);
    return error.response?.data || { message: error.message };
  }
};

export const deleteCustomerBanks = async (
  customerId: string,
  bankId: string
) => {
  try {
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("member_id", customerId);
    formData.append("bank_id", bankId);
    const response = await axios.post(
      baseUrl() + "orderhistorys/deleteCustomerBank",
      formData,
      config
    );

    console.log("deleteCustomerBanks Response :", response.data);

    return response;
  } catch (error: any) {
    console.error("Error deleteCustomerBanks bank account:", error);
    return error.response?.data || { message: error.message };
  }
};

export const updateCustomerBanks = async (
  customerId: string,
  bankdetails: any
) => {
  try {
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("member_id", customerId);
    formData.append("bank_id", bankdetails.id);
    formData.append("bank_code", bankdetails.bankCode);
    formData.append("account_number", bankdetails.accountNumber);
    formData.append("account_name", bankdetails.accountName);
    const response = await axios.post(
      baseUrl() + "orderhistorys/updateCustomerBank",
      formData,
      config
    );

    console.log("updateCustomerBanks Response :", response.data);

    return response;
  } catch (error: any) {
    console.error("Error updateCustomerBanks bank account:", error);
    return error.response?.data || { message: error.message };
  }
};

export const banks = [
  { name: "Nombank", code: "090645" },
  { name: "9Japay", code: "090629" },
  { name: "9PSB", code: "120001" },
  { name: "AB Microfinance Bank", code: "090270" },
  { name: "AG Mortgage Bank", code: "418" },
  { name: "AMJU Microfinance Bank", code: "090180" },
  { name: "ARM MFB", code: "090816" },
  { name: "ASO Savings & Loans", code: "090001" },
  { name: "Abbey Mortgage Bank", code: "070010" },
  { name: "Abucoop MFB", code: "820" },
  { name: "Access Bank", code: "044" },
  { name: "Access Yellow", code: "100052" },
  { name: "Accion Microfinance Bank", code: "090134" },
  { name: "Addosser Microfinance Bank", code: "090160" },
  { name: "Aella MFB", code: "090614" },
  { name: "Airtel Smartcash PSB", code: "120004" },
  { name: "Alternative Bank", code: "100029" },
  { name: "Ampersand Microfinance Bank", code: "090529" },
  { name: "Asset Matrix Microfinance Bank", code: "090287" },
  { name: "Auchi Microfinance Bank", code: "090264" },
  { name: "Avuenegbe MFB", code: "895" },
  { name: "BLOOMS MFB", code: "090743" },
  { name: "Bank 78", code: "110072" },
  { name: "Baobab Microfinance Bank", code: "090136" },
  { name: "Bestar MFB", code: "348" },
  { name: "Bowen Microfinance Bank", code: "50931" },
  { name: "Branch International Financial Services", code: "050006" },
  { name: "Bud Infrastructure", code: "983" },
  { name: "Build MicroFinance Bank", code: "090613" },
  { name: "Capricon Digital", code: "956" },
  { name: "Carbon", code: "100026" },
  { name: "Cash Connect MFB", code: "748" },
  { name: "Chukwunenye Microfinance Bank", code: "090490" },
  { name: "Citibank Nigeria Limited", code: "023" },
  { name: "Contec Global Infotech Limited", code: "100032" },
  { name: "Core Step MFB", code: "766" },
  { name: "Creditville MFB", code: "346" },
  { name: "Crust MFB", code: "090560" },
  { name: "DavoDani MFB", code: "50159" },
  { name: "Davodani Microfinance Bank", code: "090391" },
  { name: "Diamond Bank", code: "063" },
  { name: "Dot MFB", code: "090470" },
  { name: "E-Settlement Ltd.", code: "999999" },
  { name: "Ecobank Nigeria", code: "050" },
  { name: "Ekondo Microfinance Bank", code: "090097" },
  { name: "Enrich Microfinance Bank", code: "090539" },
  { name: "Enterprise Bank", code: "084" },
  { name: "FSDH Merchant Bank", code: "400001" },
  { name: "Fairmoney Microfinance Bank", code: "090551" },
  { name: "Fidelity Bank", code: "070" },
  { name: "Finatrust MFB", code: "608" },
  { name: "First Bank of Nigeria", code: "011" },
  { name: "First City Monument Bank", code: "214" },
  { name: "First Monnie Wallet", code: "309" },
  { name: "Flutterwave", code: "622" },
  { name: "GTBank", code: "058" },
  { name: "Globus Bank", code: "000027" },
  { name: "Goldman MFB", code: "090574" },
  { name: "Good News Microfinance Bank", code: "090495" },
  { name: "Greenacres MFB", code: "090599" },
  { name: "Grooming MFB", code: "090195" },
  { name: "Habari Pay", code: "110059" },
  { name: "Hackman Microfinance Bank", code: "090147" },
  { name: "Hala Credit Microfinance Bank", code: "090291" },
  { name: "Heritage Bank", code: "030" },
  { name: "Hope Payment Service Bank", code: "120002" },
  { name: "Ibile Microfinance Bank", code: "090118" },
  { name: "Ikoyi Osun MFB", code: "090536" },
  { name: "Jaiz Bank", code: "301" },
  { name: "Kenechukwu Microfinance Bank", code: "090602" },
  { name: "Key Stone Bank", code: "082" },
  { name: "Kolomoni MFB", code: "899" },
  { name: "Konga Pay", code: "321" },
  { name: "Kredi Microfinance Bank", code: "090380" },
  { name: "Kuda Microfinance Bank", code: "090267" },
  { name: "Lapo Microfinance Bank", code: "090177" },
  { name: "LeadCity MFB", code: "397" },
  { name: "Letshego Microfinance Bank", code: "090420" },
  { name: "Lotus Bank", code: "000029" },
  { name: "Mainstreet Microfinance Bank", code: "090171" },
  { name: "Malachy MFB", code: "648" },
  { name: "Mkobo Microfinance Bank", code: "090455" },
  { name: "Momo Payment Service Bank", code: "120003" },
  { name: "Moniepoint Microfinance Bank", code: "090405" },
  { name: "NPF MicroFinance Bank", code: "070001" },
  { name: "Netapps Technology", code: "950" },
  { name: "Nirsal MFB", code: "090194" },
  { name: "OAU Microfinance Bank", code: "090345" },
  { name: "Omiye MFB", code: "090295" },
  { name: "Paga", code: "327" },
  { name: "Page Financials", code: "070008" },
  { name: "Palmpay", code: "100033" },
  { name: "Parallex MF Bank", code: "000030" },
  { name: "Parkway Projects", code: "311" },
  { name: "PayAttitude Online", code: "329" },
  { name: "Paycom (Opay)", code: "305" },
  { name: "Paystack Titan", code: "100039" },
  { name: "Polaris Bank", code: "076" },
  { name: "Premium Trust Bank", code: "000031" },
  { name: "Pristine Divitis Microfinance Bank", code: "090499" },
  { name: "Projetcs Microfinance Bank", code: "090503" },
  { name: "Prospa Capital MFB", code: "50739" },
  { name: "Providus Bank", code: "101" },
  { name: "Randalpha Microfinance Bank", code: "090496" },
  { name: "RenMoney Microfinance Bank", code: "090198" },
  { name: "Royal Exchange Microfinance Bank", code: "090138" },
  { name: "Rubies MFB", code: "090175" },
  { name: "Safe Haven MFB", code: "090286" },
  { name: "Shalom Microfinance Bank", code: "090502" },
  { name: "Smart Cash PSB", code: "942" },
  { name: "Sparkle", code: "090325" },
  { name: "Spectrum MFB", code: "090436" },
  { name: "Stanbic IBTC Bank", code: "039" },
  { name: "Standard Chartered Bank Nigeria", code: "068" },
  { name: "Stellas MFB", code: "667" },
  { name: "Sterling Bank Plc", code: "232" },
  { name: "SunTrust Bank Nigeria Limited", code: "100" },
  { name: "Taj Bank", code: "000026" },
  { name: "Titan Trust Bank", code: "000025" },
  { name: "UNN Microfinance Bank", code: "090251" },
  { name: "Uda MFB", code: "672" },
  { name: "Unical MFB", code: "090193" },
  { name: "Union Bank of Nigeria", code: "032" },
  { name: "United Bank for Africa", code: "033" },
  { name: "Unity Bank", code: "215" },
  { name: "VFD Microfinance Bank Limited", code: "566" },
  { name: "Vale Finance", code: "050020" },
  { name: "Wema Bank", code: "035" },
  { name: "XPress MTS", code: "148" },
  { name: "XPress Payments", code: "738" },
  { name: "XPress Wallet", code: "391" },
  { name: "Yello Digital Services", code: "964" },
  { name: "ZWallet", code: "792" },
  { name: "Zenith Bank", code: "057" },
  { name: "Zikora Microfinance Bank", code: "090504" },
  { name: "eTranzact", code: "306" },
];

export const verifyBankAccount = async (
  accountNumber: string,
  bankCode: string
) => {
  try {
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("accountNumber", accountNumber);
    formData.append("bankCode", bankCode);

    console.log("Payload:", [...formData]);

    const response = await axios.post(
      baseUrl() + "warehouses/getAccountName",
      formData,
      config
    );

    console.log("Response:", response.data);

    return response.data.data;
  } catch (error: any) {
    console.error("Error verifying bank account:", error);
    return error.response?.data || { message: error.message };
  }
};